// extracted by mini-css-extract-plugin
module.exports = {"wythvuy":"wythvuy","t16m3o3k":"t16m3o3k"};